exports.install = function (Vue) {

    var ApiHost = "https://s.it-fortress.com";

    Vue.prototype.submit = function(name, email, message) {
        
        return this.$http.post(ApiHost + '/contact.php', {name: name, email: email, message: message}, { emulateJSON: true });
        
    };

};